import { z } from "zod";

import { fetchWithError } from "@nens/react-query-utils";

export const exportSchema = z.object({
  task_id: z.string(),
  url: z.string(),
});

export type Export = z.infer<typeof exportSchema>;

export async function fetchTimeseriesExport(uuids: string[], start: string, end: string) {
  const params: string[] = [`start=${start}`, `end=${end}`];

  // Add UUIDs of timeseries to params
  uuids.map((uuid) => params.push(`uuid=${uuid}`));

  const url = `/api/v4/timeseries/export/?${params.join("&")}`;

  const json = await fetchWithError(url);
  return exportSchema.parse(json);
}
